export const PROTOCOLS_SUPPORTED_AS_LINKS_IN_KEY_VALUE = [
  'file:///',
  'http://',
  'https://',
  'vscode://',
];
